/* eslint-disable */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import copy from 'copy-to-clipboard';

import { convertFromRaw } from 'draft-js';
import { stateToHTML } from 'draft-js-export-html';
// import { loadStripe } from '@stripe/stripe-js';
import { useHistory } from 'react-router-dom';
import { useMutation /*, useQuery*/ } from '@apollo/client';
import { useQuery } from '@apollo/client';
import { message, notification } from 'antd';
import { useIntercom } from 'react-use-intercom';

import utils from 'utils/utils';
import { escapeHTML } from 'utils/xss';
import Loader from 'components/Loader';
import PublishContent from './components/PublishContent';
import helpers from 'helpers/proposal';
import helpersUtils from 'helpers';
import proposalTimer from './helpers/proposalTimer';
import { ExpiredProposalModal, PublishModals } from './modals';
import { PROPOSAL_SUBSCRIPTION_TOPIC } from 'constants/index';
import {
  CREATE_CLIENT_SQUARE_PAYMENT_SESSION,
  CREATE_CLIENT_STRIPE_PAYMENT_SESSION,
} from 'graphql/mutations/integrationMutation';
import { FETCH_PROPOSAL_BACKUP } from 'graphql/queries/proposalBackups';
import { UPDATE_LIBRARY_TEMPLATE_RESTORE_MUTATION } from 'graphql/mutations/contentLibraryMutations';

// import { POLLING_INTERVAL } from 'constants/index';
// import { PING_POLLING } from 'graphql/queries/pollingQueries';
import useSessionStorage from 'hooks/useSessionStorage';
import { removeSpamUrls, formatSpamUrls } from 'utils/spamUrl';

import './Publish.scss';
import { useProposalContext } from 'context/proposal';
import PasswordVerify from '../PasswordVerify/PasswordVerify';
import Cookies from 'js-cookie';

// Handles the rendering and logic of the Proposal in its published mode
// It’s used for either the “Preview” mode by the user (/pd/ url)
// Or the actual link the client gets (/c/ url).
// Also the PDF renderer is using the url (/PDF/) to render the pdf and this is also rendered by these components)

const Publish = (props) => {
  const {
    config,
    user,
    match: { params },
    usersTeam,
    updateProposalClient,
    isTemplate,
    isSection,
    isHistory,
    isSavingForm,
    setIsSavingForm,
    wixPreview,
    setOpenWixPreview,
    clientWixPreview,
    templateWixPreview,
    isHeader,
    templateUserWixPreview,
    path,
    isWix,
  } = props;

  const {
    proposal,
    propRef,
    setProp,
    downloadPdf,
    downloadingPDF,
    handleDownloadCancel,
    subscribeToUpdateProposal,
    isEditingModal,
    proposalSettings,
    preventReload,
    updateProposalPreHandler: updateProposal,
    setTemplate,
  } = useProposalContext();

  const [updateTemplateRestore] = useMutation(UPDATE_LIBRARY_TEMPLATE_RESTORE_MUTATION);

  const clientView = window.location.pathname.startsWith('/cd/');
  const pdfView = window.location.pathname.startsWith('/PDF/');

  const TAB_ID = Date.now().toString();
  const [session, setSession] = useSessionStorage('session', {
    _id: '',
    visit: 1,
    tab_id: TAB_ID,
    last_visited: Date.now(),
  });

  const [isPublishing, setIsPublishing] = useState(false);
  const [proposalUnPublished, setProposalUnPublished] = useState(false);
  const [proposalPublished, setProposalPublished] = useState(false);
  const [makePayment, setMakePayment] = useState(false);
  const [logTime, setLogTime] = useState(0);
  const [stripe, setStripe] = useState('');
  const [paymentError, setPaymentError] = useState('');
  const [makingPayment, setMakingPayment] = useState(false);
  const [paymentStatus, setPaymentStatus] = useState('');
  const [downloadPDFError, setDownloadPDFError] = useState('');
  // const [lastUpdate, setLastUpdate] = useState('');
  const [isClient, setIsClient] = useState(true);
  const [spamUrls, setSpamUrls] = useState({});
  const [prop, setProposal] = useState({});
  const [backupPreviewId, setBackupPreviewId] = useState(null);
  const [backupPreviewStack, setBackupPreviewStack] = useState({});
  const [restoring, setRestoring] = useState(false);

  const history = useHistory();
  const { trackEvent, shutdown } = useIntercom();

  const pageTimerRef = React.useRef({ 1: 0 });
  const currentPageRef = React.useRef(1);
  const pageStartTimeRef = React.useRef(null);

  const processProposal = (proposal) => {
    // include more such function here

    if (clientView || pdfView) {
      // replace spam url with [dot] to make it non navigable
      return removeSpamUrls(proposal, formatSpamUrls(proposal?.spamUrls) || spamUrls);
    }

    return proposal;
  };

  const onBackupPreviewFetch = ({ fetchProposalBackup }) => {
    try {
      if (fetchProposalBackup?.proposal) {
        const _proposal = JSON.parse(fetchProposalBackup.proposal);
        setBackupPreviewStack((prev) => {
          const data = { ...prev, [backupPreviewId]: _proposal };

          // set the live version of proposal in cache if not set previously
          if (!data?.live) {
            data.live = prop;
          }

          return data;
        });
        setProposal((prev) => ({ ...prev, ..._proposal }));
      }
    } catch (error) {
      console.error('Error P135', error);
    }
  };

  const shouldSkip =
    backupPreviewId === 'live' || !backupPreviewId || backupPreviewStack[backupPreviewId];

  // fetch backuped proposal and store in cache
  const { loading: backupPreviewLoading, refetch: refetchBackupPreview } = useQuery(
    FETCH_PROPOSAL_BACKUP,
    {
      skip: shouldSkip,
      variables: shouldSkip ? undefined : { backupId: backupPreviewId },
      fetchPolicy: 'network-only',
      onCompleted: onBackupPreviewFetch,
    }
  );

  useEffect(() => {
    if (!proposal || backupPreviewId) {
      return;
    }

    setProposal(processProposal(proposal));
  }, [proposal]);

  useEffect(() => {
    // when backupPreviewId changes refetch backup preview proposal
    if (!backupPreviewId) {
      return;
    }

    if (backupPreviewStack[backupPreviewId]) {
      // if backup is available in cache no need to refetch
      setProposal((prev) => ({ ...prev, ...backupPreviewStack[backupPreviewId] }));
      return;
    }

    refetchBackupPreview({ backupId: backupPreviewId });
  }, [backupPreviewId, refetchBackupPreview]);

  const delegate = (el, evt, sel, handler) => {
    el.addEventListener(evt, function (event) {
      var t = event.target;
      while (t && t !== this) {
        if (t instanceof Element && t.matches(sel)) {
          handler.call(t, event);
        }
        t = t.parentNode;
      }
    });
  };

  useEffect(() => {
    if (prop?.spamUrls) {
      setSpamUrls(formatSpamUrls(prop.spamUrls));
    }
  }, [prop?.spamUrls]);

  /* eslint-disable*/
  useEffect(() => {
    // Run shutdown if needed
    if (pdfView || clientView || clientWixPreview) {
      shutdown();
    }

    const classesToAdd = ['publish-body'];

    if (!params.cid && !clientWixPreview && !pdfView) {
      classesToAdd.push('publish-preview');
    }

    if (pdfView) {
      classesToAdd.push('PDF');
    } else if (path === '/pd/:id') {
      classesToAdd.push('editor-preview');
    } else if (isHistory) {
      classesToAdd.push('history-preview');
    } else if (clientView || clientWixPreview) {
      classesToAdd.push('client-preview');
    }

    document.body.classList.add(...classesToAdd);

    // for pdf, call helper function
    if (pdfView) {
      setTimeout(() => {
        helpers.pdfImageModifier('.image-figure img');
      }, 50);
    }

    delegate(document, 'click', '.section-wrapper a', function (event) {
      event.preventDefault();

      var url = event.target.closest('.section-wrapper a').getAttribute('href');
      if (!url) {
        return;
      }
      // in client view stop if spam url
      else if (clientView && url.includes('[dot]')) {
        return;
      } else if (
        !url.startsWith('http') &&
        url.indexOf('tel') === -1 &&
        url.indexOf('mailto') === -1
      ) {
        url = 'http://' + url;
      }

      try {
        url && window.open(url);
      } catch (err) {
        console.error('ERROR opening URL', url);
      }
    });

    return () => {
      document.body.classList.remove(
        'publish-body',
        'publish-preview',
        'PDF',
        'history-preview',
        'editor-preview'
      );

      document.removeEventListener('click', () => {});
      setMakePayment(false);
      setLogTime('');
    };
  }, []);

  useEffect(() => {
    // Only run proposal timer for real users, not bots
    if (!helpersUtils.isBotOrPrerender()) {
      proposalTimer.onSavingFormChange(isSavingForm);
    }
  }, [isSavingForm]);

  useEffect(() => {
    let unsubscribe = () => {};
    try {
      unsubscribe = subscribeToUpdateProposal();
    } catch (error) {
      console.log(error);
    }
    return () => unsubscribe && unsubscribe();
  }, []);

  useEffect(() => {
    if (!preventReload) {
      window.onunload = window.onbeforeunload = null;
    }
  }, [preventReload]);

  useEffect(() => {
    // if logged in user is NOT owner of the proposal OR not logged in then its a client
    const isClientValue =
      (!!params.cid && ((user && user?._id !== proposal?.uid) || !user)) ||
      (clientWixPreview && !pdfView);
    setIsClient(isClientValue);

    // Only load for real users, not bots
    if (!proposal?._id || helpersUtils.isBotOrPrerender()) {
      return;
    }

    const _session = {
      ...session,
    };

    if (isClientValue && session?.visit) {
      // first visit of this proposal
      if (_session._id !== params.cid && _session._id !== window.proposalId) {
        _session._id = params.cid || window.proposalId;
        // assign new tab id
        _session.tab_id = Date.now().toString();
        _session.visit = 1;
        delete _session.logIndex;
      }
      // subsequent visit
      else {
        _session.visit = session.visit + 1;
      }

      setSession({
        ..._session,
        last_visited: Date.now(),
      });
    }

    const callLogTimer = () => {
      proposalTimer.logTimer({
        isClient: isClientValue,
        prop: propRef?.current,
        updateProposalClient,
        setLogTime,
        session: _session,
        pageTimerRef,
        currentPageRef,
        pageStartTimeRef,
      });
    };

    // if fresh new session
    if (_session.visit === 1 && !pdfView) {
      callLogTimer();
    }

    const isTracking = clientView || (clientWixPreview && !pdfView);
    const cleanups = [];

    if (isTracking) {
      // give the page clocks a starting point at mount, so that time spent
      // reading page 1 before the first interaction is still counted
      proposalTimer.registerPageRefs({ pageTimerRef, currentPageRef, pageStartTimeRef });

      if (isClientValue) {
        proposalTimer.startTimer(logTime);
        proposalTimer.resumeAll();
        proposalTimer.startIdleWatcher();
        cleanups.push(() => proposalTimer.stopIdleWatcher());
      }

      const on = (target, event, handler, opts) => {
        target.addEventListener(event, handler, opts);
        cleanups.push(() => target.removeEventListener(event, handler, opts));
      };

      const onActivity = () => proposalTimer.markActivity();

      // any of these means the reader is still here — resume if idle-paused
      ['mousemove', 'keydown', 'scroll', 'touchstart', 'click'].forEach((event) =>
        on(window, event, onActivity, { passive: true, capture: true })
      );

      // the reliable "user is gone" signal: fires on tab switch, tab close,
      // app backgrounding and screen lock, where blur/unload do not
      const onVisibilityChange = () => {
        if (document.visibilityState === 'hidden') {
          proposalTimer.pauseAll();
          callLogTimer();
        } else {
          proposalTimer.resumeAll();
        }
      };
      on(document, 'visibilitychange', onVisibilityChange);

      // backstop for browsers that tear the page down without a final
      // visibilitychange (notably bfcache navigations on Safari)
      const onPageHide = () => {
        proposalTimer.pauseAll();
        callLogTimer();
      };
      on(window, 'pagehide', onPageHide);

      const onBlur = () => {
        proposalTimer.pauseAll();
        callLogTimer();
      };
      on(window, 'blur', onBlur);

      const onFocus = () => proposalTimer.resumeAll();
      on(window, 'focus', onFocus);
    }

    if (isClientValue && proposal && clientView) {
      if (proposal?.stripe?.stripe_user_id) {
        (async () =>
          import('@stripe/stripe-js').then(async (stripe) =>
            setStripe(
              await stripe.loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY, {
                stripeAccount: proposal.stripe.stripe_user_id,
              })
            )
          ))();
      }
    }

    return () => cleanups.forEach((cleanup) => cleanup());
  }, []);

  useEffect(() => {
    const stripeStatus = utils.getQueryStringValue('stripestatus');
    const paymentStatus = utils.getQueryStringValue('paymentstatus');

    if (stripeStatus && stripeStatus === 'success') {
      history.push(`/cd/${params.cid}?paymentstatus=success`);
    } else if (stripeStatus === 'canceled') {
      setPaymentError('Payment Declined');
      history.push(`/cd/${params.cid}?paymentstatus=failed`);
    }

    if (paymentStatus) {
      setPaymentStatus(paymentStatus);
    }
  }, [location.search]);
  /* eslint-enable */

  useEffect(() => {
    // Only set proposal seen for real users, not bots
    if (
      prop?._id &&
      isClient &&
      ((params.cid && clientView) || (clientWixPreview && !pdfView)) &&
      !helpersUtils.isBotOrPrerender() &&
      !(
        prop.state === 'declined' ||
        (prop.expiryDate && moment(new Date()).isAfter(moment(new Date(prop.expiryDate))))
      )
    ) {
      proposalTimer.setseen(params, prop, updateProposalClient, clientWixPreview);
    }
  }, [prop, params, isClient, updateProposalClient, clientWixPreview, pdfView, clientView]);

  const [createClientStripeSession] = useMutation(CREATE_CLIENT_STRIPE_PAYMENT_SESSION, {
    async onCompleted(data) {
      // When the customer clicks on the button, redirect them to Checkout.
      const { error } = await stripe.redirectToCheckout({
        sessionId: data.createClientStripePaymentSession,
      });

      // If `redirectToCheckout` fails due to a browser or network
      // error, display the localized error message to your customer
      // using `error.message`.
      if (error) {
        setPaymentError(error);
        setMakingPayment(false);
      } else {
        setMakingPayment(false);
        setPaymentError('');
      }
    },
    onError: (err) => {
      console.log(err);
      setMakingPayment(false);
      setPaymentError('Payment Failed');
    },
  });

  const [createClientSquareSession] = useMutation(CREATE_CLIENT_SQUARE_PAYMENT_SESSION, {
    async onCompleted(data) {
      window.location.href = data.createClientSquarePaymentSession;
    },
    onError: (err) => {
      setMakingPayment(false);
      setPaymentError('Payment Failed');
    },
  });

  /*
   * Replace polling by subscription
   *
  const {
    data: pollingResponse,
    // startPolling,
    // stopPolling,
  } = useQuery(PING_POLLING, {
    variables: {
      from: 'Publish',
      proposalId: prop._id,
      userId: user?._id || '',
      teamId: user?.teamId || '',
    },
    pollInterval: POLLING_INTERVAL.proposal * 1000,
    fetchPolicy: 'no-cache',
  });

  // console.log("re rendered ?")

  useEffect(() => {
    if (pollingResponse) {
      // if (isFirst) {
      //   startPolling(POLLING_INTERVAL.proposal * 1000);
      //   setIsFirst(false);
      // }
      // console.log("inside polling response")
      let typename,
        proposal = undefined;
      typename = pollingResponse?.pingPolling?.typename;
      proposal = pollingResponse?.pingPolling?.proposal;
      if (
        typename &&
        typename !== 'pong' &&
        lastUpdate !== JSON.stringify(pollingResponse?.pingPolling)
      ) {
        // console.log("updated")
        setLastUpdate(JSON.stringify(pollingResponse?.pingPolling));
        if (
          user &&
          user?._id !== proposal?.uid &&
          user?.teamId !== proposal?.auid &&
          user?._id !== proposal?.auid &&
          user?.teamId !== proposal?.uid
        )
          return;

        if (params.cid && params.cid !== proposal._id) {
          return;
        }

        if (params.id && params.id !== proposal._id) {
          return;
        }

        if (params.sid && params.sid !== proposal._id) {
          return;
        }

        if (params.tid && params.tid !== proposal._id) {
          return;
        }

        if (params.pid && params.pid !== proposal.pid) {
          return;
        }

        if (window.proposalId && window.proposalId !== proposal.wixProposalId) {
          return;
        }

        if (typename === 'UPDATE_PROPOSAL') {
          propRef.current = proposal;
          setProp(proposal);
          return { fetchProposal: proposal };
        }
      }
    }
  }, [
    pollingResponse,
    params,
    propRef,
    setProp,
    user,
    lastUpdate,
    setLastUpdate,
    // isFirst,
    // setIsFirst,
    // startPolling,
  ]);
  */

  /*
   * No manual start and stop polling 
   *
  useEffect(() => {
    if (sessionStorage.getItem('shouldPoll') === 'true') {
      if (!props.shouldPoll) {
        sessionStorage.setItem('shouldPoll', false);
        stopPolling();
      }
    } else {
      if (props.shouldPoll) {
        sessionStorage.setItem('shouldPoll', true);
        startPolling(POLLING_INTERVAL.proposal * 1000);
      }
    }
  });
  */

  useEffect(() => {
    let unsubscribe = () => {};
    try {
      unsubscribe = subscribeToUpdateProposal();
    } catch (error) {
      console.log(error);
    }
    return () => unsubscribe && unsubscribe();
  }, [subscribeToUpdateProposal]);

  if (!prop) {
    return (
      <div className="not-found">
        <h1>Sorry, there is nothing here</h1>
      </div>
    );
  }

  if (!isSection && (!prop?._id || !config)) {
    return <Loader />;
  }

  const restoreProposal = (backupId) => {
    const edited = new Date();
    setRestoring({ state: 'restoring', backupId });
    const topic = `${PROPOSAL_SUBSCRIPTION_TOPIC}_${prop?.channel || prop?.auid || prop?.uid}`;
    const newProposal = {
      ...prop,
      ...backupPreviewStack[backupId],
      edited,
    };

    const handleRestoreResponse = ({ data, errors }) => {
      setRestoring({ state: 'restored', backupId });
      setProposal((prev) => ({ ...prev, edited }));

      if (isTemplate && data?.updateTemplate) {
        const restored = { ...propRef.current, ...data.updateTemplate };
        propRef.current = restored;
        setProp(restored);
        setTemplate(restored);
        setProposal(processProposal(restored));
        setBackupPreviewStack((prev) => ({ ...prev, live: restored }));
        message.success('Template version restored');
      } else if (!isTemplate && data) {
        setBackupPreviewStack((prev) => ({ ...prev, live: newProposal }));
        message.success('Proposal version restored');
      } else if (errors?.message) {
        message.error(errors?.message.replace('proposal', isTemplate ? 'template' : 'proposal'));
      }
    };

    if (isTemplate) {
      // for template
      updateTemplateRestore({
        variables: {
          topic,
          template: { id: prop._id, ...prop, edited, backupId },
          templateUrl: '',
        },
      })
        .then(handleRestoreResponse)
        .catch((errors) => handleRestoreResponse({ errors }));
      return;
    }

    // for proposal
    updateProposal(
      {
        variables: {
          topic,
          updateType: 'restore_backup',
          proposal: {
            id: prop._id,
            _id: prop._id,
            channel: prop.channel,
            pid: prop.pid,
            uid: prop.uid,
            auid: prop.auid,
            prevState: prop.state,
            backupId: backupId,
            edited,
          },
        },
      },
      {
        ...newProposal,
      }
    )
      .then(handleRestoreResponse)
      .catch((errors) => handleRestoreResponse({ errors }));
  };

  const publishProposal = (publish = true) => {
    if (prop.published && prop.state === 'published' && wixPreview) {
      window?.proposalApi?.send(window.proposalId);
    } else {
      // publish OR unpublish
      setIsPublishing(true);

      if (!prop?.wixProposalId) {
        if (publish) {
          trackEvent('publishprop', {
            id: prop._id,
          });
        } else {
          trackEvent('unpublishprop', {
            id: prop._id,
          });
        }
      }

      const proposalInfo = {
        id: prop._id,
        _id: prop._id,
        pid: prop.pid,
        uid: prop.uid,
        auid: prop.auid,
        published: publish ? new Date(new Date().toUTCString().slice(0, -4)) : null,
        state: prop.state === 'approved' ? prop.state : publish ? 'published' : 'edit',
        prevState: prop.state,
      };

      setTimeout(() => {
        updateProposal(
          {
            variables: {
              topic: `${PROPOSAL_SUBSCRIPTION_TOPIC}_${
                proposalInfo?.channel || proposalInfo?.auid || proposalInfo?.uid
              }`,
              updateType: publish ? proposalInfo.state : 'unpublished',
              proposal: proposalInfo,
            },
          },
          {
            ...prop,
            ...proposalInfo,
          }
        ).then(({ data, errors }) => {
          if (data) {
            if (publish) {
              if (wixPreview) {
                window?.proposalApi?.send(window.proposalId);
              } else {
                setProposalPublished(true);
              }
            } else {
              setProposalUnPublished(true);
            }
            setIsPublishing(false);
          } else if (errors?.message) {
            setIsPublishing(false);
            notification.error({
              message: 'Proposal Publish Failed',
              description: 'Proposal Status not valid',
            });
          }
          setProp({ ...prop, ...proposalInfo });
        });
      }, 1500);
    }
  };

  const publishedProposalLink = (type) => {
    if (type === 'unshortened') {
      return `${window.location.origin}/cd/${prop._id}`;
    }

    const hostForLink = `.goprospero.com/${helpers.porposalPdfLinkPath(prop._id)}`;

    let pdfLink = user ? `https://${user.domain}${hostForLink}` : '';
    const cuid = user && user._id;

    if (cuid !== prop.uid) {
      const teamMember = usersTeam && usersTeam.find((user) => user._id === prop.uid);
      if (teamMember) {
        pdfLink = `https://${teamMember.domain}${hostForLink}`;
      } else {
        pdfLink = '';
      }
    }

    return pdfLink;
  };

  const copyPropsalLink = (linkType) => {
    setProposalPublished(false);
    copy(publishedProposalLink(linkType));
    message.success('Copied to Clipboard');

    if (!clientView) {
      window.ga('send', 'event', 'click', 'click-copy-link', publishedProposalLink());
      window.ga('send', 'pageview', '/event/click-copy-link');
    }

    trackEvent('click-copy-link', {
      pid: prop?.pid,
      id: prop?._id,
      value: publishedProposalLink(),
    });
  };

  const clientMakesPayment = (amount) => {
    setMakingPayment(true);

    const currency = prop.clientPayableCurrency
      ? prop.clientPayableCurrency
      : prop.stripe.currency
      ? prop.stripe.currency
      : 'usd';

    if (prop.stripe.type === 'square' && prop.stripe.isActive) {
      createClientSquareSession({
        variables: {
          amount,
          currency,
          proposalLabel: prop.clientPayableLabel,
          proposalId: prop._id,
        },
      });
    } else {
      createClientStripeSession({
        variables: {
          amount,
          currency,
          proposalLabel: prop.clientPayableLabel,
          proposalId: prop._id,
        },
      });
    }
  };

  if (pdfView) {
    setTimeout(() => {
      helpers.updateTableZoom();
    }, 50);
  }

  const { expiryDate, state: proposalState } = prop;
  // Check proposal is expired or not
  if ((expiryDate || proposalState === 'declined') && proposalState !== 'approved' && !pdfView) {
    const isProposalExpired = moment(new Date()).isAfter(moment(new Date(expiryDate)));
    const isProposalDeclined = proposalState === 'declined';

    const {
      callButton,
      contactnumber,
      email,
      expiryMessage,
      language,
      draft: { header },
      client,
    } = prop;

    const contactNumber = contactnumber && contactnumber.replace(/\s/g, '');

    const message = expiryMessage || 'This proposal already expired';
    let nameHtmlClean;
    if (header) {
      let nameHtml = header.name;
      if (header.rawname) {
        const names = convertFromRaw(header.rawname);
        nameHtml = stateToHTML(names);
      }
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = nameHtml;
      nameHtmlClean = tempDiv.textContent;
    } else {
      nameHtmlClean = escapeHTML(client?.contact || '');
    }

    if ((isProposalExpired || isProposalDeclined) && !isHistory) {
      return (
        <>
          <ExpiredProposalModal
            title="Expired"
            subTitle={message}
            name={nameHtmlClean.split(' ')[0]}
            contactNumber={contactNumber}
            email={email}
            showCallButton
            callButton={callButton}
            language={language?.toLowerCase()}
            config={config}
            isClient={isClient}
          />
        </>
      );
    }
  }

  return (
    <>
      <PublishModals
        proposal={prop}
        user={user}
        history={history}
        paymentError={paymentError}
        setPaymentError={setPaymentError}
        copyPropsalLink={copyPropsalLink}
        downloadPdf={downloadPdf}
        publishedProposalLink={publishedProposalLink}
        proposalUnPublished={proposalUnPublished}
        proposalPublished={proposalPublished}
        makePayment={makePayment}
        makingPayment={makingPayment}
        paymentStatus={paymentStatus}
        setProposalUnPublished={setProposalUnPublished}
        setProposalPublished={setProposalPublished}
        setProposal={setProposal}
        setMakePayment={setMakePayment}
        clientMakesPayment={clientMakesPayment}
        setPaymentStatus={setPaymentStatus}
        downloadPDFError={downloadPDFError}
        setDownloadPDFError={setDownloadPDFError}
        isEditingModal={isEditingModal}
        isHistory={isHistory}
      />
      <PublishContent
        copyPropsalLink={copyPropsalLink}
        publishedProposalLink={publishedProposalLink}
        isPublishing={isPublishing}
        config={config}
        prop={prop}
        user={user}
        setProp={setProp}
        updateProposalClient={updateProposalClient}
        templateWixPreview={templateWixPreview}
        templateUserWixPreview={templateUserWixPreview}
        publishProposal={publishProposal}
        restoreProposal={restoreProposal}
        setMakePayment={setMakePayment}
        isTemplate={isTemplate}
        isSection={isSection}
        isHeader={isHeader}
        isHistory={isHistory}
        downloadPdf={downloadPdf}
        downloadingPDF={downloadingPDF}
        handleDownloadCancel={handleDownloadCancel}
        location={props.location}
        proposalSettings={proposalSettings}
        isSavingForm={isSavingForm}
        setIsSavingForm={setIsSavingForm}
        wixPreview={wixPreview}
        setOpenWixPreview={setOpenWixPreview}
        clientWixPreview={clientWixPreview}
        isEditingModal={isEditingModal}
        spamUrls={spamUrls}
        setProposalPublished={setProposalPublished}
        path={path}
        backupPreviewId={backupPreviewId}
        setBackupPreviewId={setBackupPreviewId}
        backupPreviewLoading={backupPreviewLoading}
        restoring={restoring}
        isWix={isWix}
        pageTimerRef={pageTimerRef}
        currentPageRef={currentPageRef}
        pageStartTimeRef={pageStartTimeRef}
      />
    </>
  );
};

Publish.defaultProps = {
  cuser: '',
  prop: '',
  propRef: {},
  config: null,
  usersTeam: [],
  isTemplate: false,
  isSection: false,
  isHistory: false,
  updateProposalClient: () => {},
  setProp: () => {},
  wixPreview: false,
  setOpenWixPreview: () => {},
  clientWixPreview: false,
};

Publish.propTypes = {
  user: PropTypes.oneOfType([PropTypes.instanceOf(Object), PropTypes.string]),
  prop: PropTypes.oneOfType([PropTypes.instanceOf(Object), PropTypes.string]),
  propRef: PropTypes.instanceOf(Object),
  config: PropTypes.instanceOf(Object),
  match: PropTypes.instanceOf(Object).isRequired,
  usersTeam: PropTypes.arrayOf(PropTypes.shape({})),
  updateProposalClient: PropTypes.func,
  isTemplate: PropTypes.bool,
  isSection: PropTypes.bool,
  isHistory: PropTypes.bool,
  wixPreview: PropTypes.bool,
  clientWixPreview: PropTypes.bool,
  setOpenWixPreview: PropTypes.func,
};

export default Publish;
